import { PROMOTIONS } from '../shared/promotion';

export const Promotions=(state=PROMOTIONS,action)=>{
    switch (action.type) {
      
        default:
            return state;
            
    }

};

